import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dataLoaded: false,
    chartData: {
      production: [],
      rd: [],
      exports: [],
      employment: []
    },
    selectedCountry: 'France',
    selectedCompetitor: 'Chine',
    competitors: ['Chine', 'Allemagne'],
    competitorResourceIds: {
      'Chine': {
        indicator1: '71d9f379-5d71-4b06-99b5-75ac32239e0b',
        indicator2: 'd353484d-d159-45dc-85cf-d4dc5f0ed47f',
        indicator3: 'd5670741-91c2-4000-aba5-793eb4909ee0',
        indicator4: 'a1387473-fa48-4e35-bbde-f6c6084cde63'
      },
      'Allemagne': {
        indicator1: '6ddc7294-69a5-43e2-bf78-8fab4f4875d6',
        indicator2: '10a467ff-c8e9-4ebb-9fbf-71c6f5433fba',
        indicator3: '591d5343-a43a-4038-aa24-ee583f9a9385',
        indicator4: 'd3ddb7df-3c1b-4a3b-a22c-d742971cf055'
      }
    },
    countryToApiName: {
      'Autriche': 'Austria',
      'Belgique': 'Belgium',
      'Bulgarie': 'Bulgaria',
      'Croatie': 'Croatia',
      'Chypre': 'Cyprus',
      'République Tchèque': 'Czechia',
      'Danemark': 'Denmark',
      'Estonie': 'Estonia',
      'Finlande': 'Finland',
      'France': 'France',
      'Allemagne': 'Germany',
      'Grèce': 'Greece',
      'Hongrie': 'Hungary',
      'Irlande': 'Ireland',
      'Italie': 'Italy',
      'Lettonie': 'Latvia',
      'Lituanie': 'Lithuania',
      'Luxembourg': 'Luxembourg',
      'Malte': 'Malta',
      'Pays-Bas': 'Netherlands',
      'Pologne': 'Poland',
      'Portugal': 'Portugal',
      'Roumanie': 'Romania',
      'Slovaquie': 'Slovakia',
      'Slovénie': 'Slovenia',
      'Espagne': 'Spain',
      'Suède': 'Sweden',
      'États-Unis': 'USA'
    },
    countryTranslations: {
      "Afghanistan": "Afghanistan",
      "Albania": "Albanie",
      "Algeria": "Algérie",
      "American Samoa": "Samoa américaines",
      "Andorra": "Andorre",
      "Angola": "Angola",
      "Anguilla": "Anguilla",
      "Antarctica": "Antarctique",
      "Antigua and Barbuda": "Antigua-et-Barbuda",
      "Argentina": "Argentine",
      "Armenia": "Arménie",
      "Aruba": "Aruba",
      "Australia": "Australie",
      "Austria": "Autriche",
      "Azerbaijan": "Azerbaïdjan",
      "Bahamas": "Bahamas",
      "Bahrain": "Bahreïn",
      "Bangladesh": "Bangladesh",
      "Barbados": "Barbade",
      "Belarus": "Biélorussie",
      "Belgium": "Belgique",
      "Belize": "Belize",
      "Benin": "Bénin",
      "Bermuda": "Bermudes",
      "Bhutan": "Bhoutan",
      "Bolivia (Plurinational State of)": "Bolivie",
      "Bosnia Herzegovina": "Bosnie-Herzégovine",
      "Botswana": "Botswana",
      "Brazil": "Brésil",
      "Brunei Darussalam": "Brunei",
      "Bulgaria": "Bulgarie",
      "Burkina Faso": "Burkina Faso",
      "Burundi": "Burundi",
      "Cambodia": "Cambodge",
      "Cameroon": "Cameroun",
      "Canada": "Canada",
      "Cabo Verde": "Cap-Vert",
      "Central African Rep.": "République centrafricaine",
      "Chad": "Tchad",
      "Chile": "Chili",
      "China": "Chine",
      "Colombia": "Colombie",
      "Comoros": "Comores",
      "Congo": "Congo",
      "Dem. Rep. of the Congo": "République démocratique du Congo",
      "Costa Rica": "Costa Rica",
      "Côte d'Ivoire": "Côte d'Ivoire",
      "Croatia": "Croatie",
      "Cuba": "Cuba",
      "Cyprus": "Chypre",
      "Czechia": "République Tchèque",
      "Czech Republic": "République tchèque",
      "Denmark": "Danemark",
      "Djibouti": "Djibouti",
      "Dominica": "Dominique",
      "Dominican Rep.": "République dominicaine",
      "Ecuador": "Équateur",
      "Egypt": "Égypte",
      "El Salvador": "Salvador",
      "Equatorial Guinea": "Guinée équatoriale",
      "Eritrea": "Érythrée",
      "Estonia": "Estonie",
      "Ethiopia": "Éthiopie",
      "Finland": "Finlande",
      "France": "France",
      "Germany": "Allemagne",
      "Greece": "Grèce",
      "Hungary": "Hongrie",
      "Iceland": "Islande",
      "India": "Inde",
      "Indonesia": "Indonésie",
      "Iran": "Iran",
      "Iraq": "Irak",
      "Ireland": "Irlande",
      "Israel": "Israël",
      "Italy": "Italie",
      "Japan": "Japon",
      "Kazakhstan": "Kazakhstan",
      "Kenya": "Kenya",
      "Rep. of Korea": "Corée du Sud",
      "Latvia": "Lettonie",
      "Lithuania": "Lituanie",
      "Luxembourg": "Luxembourg",
      "Malaysia": "Malaisie",
      "Malta": "Malte",
      "Mexico": "Mexique",
      "Morocco": "Maroc",
      "Netherlands": "Pays-Bas",
      "Norway": "Norvège",
      "Poland": "Pologne",
      "Portugal": "Portugal",
      "Romania": "Roumanie",
      "Russian Federation": "Russie",
      "Saudi Arabia": "Arabie saoudite",
      "Serbia": "Serbie",
      "Singapore": "Singapour",
      "Slovakia": "Slovaquie",
      "Slovenia": "Slovénie",
      "Spain": "Espagne",
      "Sweden": "Suède",
      "Switzerland": "Suisse",
      "Türkiye": "Turquie",
      "Turkey": "Turquie",
      "Ukraine": "Ukraine",
      "United Kingdom": "Royaume-Uni",
      "United Arab Emirates": "Émirats arabes unis",
      "USA": "États-Unis",
      "United States": "États-Unis",
      "United States of America": "États-Unis",
      "Viet Nam": "Viêt Nam",
      "South Africa": "Afrique du Sud"
    },
    selectedCategory: `Fabrication de machines‑outils`,
    categoryToId: {
      ' Fabrication d\'articles textiles confectionnés, sauf habillement': 'aafd101b-51d7-4a7d-b32c-f749116da71c',
      ' Préparation et tannage du cuir': '0239d566-671c-4fd2-a78b-1f44870039bb',
      'Activités de spectacle vivant, de musique et autres activités artistiques': 'cf97912b-a85b-4623-b7f3-ac11df19b4f8',
      'Activités d\'imprimerie': 'f2d4d842-85f7-4089-923a-448f186f04a3',
      'Activités photographiques': 'e2b9e98e-fc8c-42b0-8af1-e810514b2af8',
      'Apprêt et teinture de fourrures; fabrication d\'articles en fourrure': 'c188b148-4ff4-46b5-a2dd-b4acd1bf24a7',
      'Autres': '19373cc1-192b-464b-bd87-0a912b6f338c',
      'Autres activités d\'extraction n.c.a.': 'cd049510-dd2a-42a6-bf57-35227b92a74a',
      'Autres activités d\'édition': '3593cb84-7ef4-42fc-b309-2bcf8e9e0347',
      'Autres activités manufacturières n.c.a.': '8f10bb4b-1652-4be0-a92e-fee2c91c2db1',
      'Autres élevages d\'animaux; production de produits animaux n.c.a.': 'efee8258-fec7-43d9-bc9d-10bbe30d0de1',
      'Biens non classés ailleurs': 'e2e066df-7908-4a77-bdd5-e5215bd6da5e',
      'Coiffure et autres soins de beauté': 'aa4f938e-8714-4b5b-9aa6-69b1826d642c',
      'Construction et réparation de bateaux de plaisance et de sport': '8ab9a2af-5673-470c-b4b0-4924af7706f5',
      'Construction et réparation de navires': '15aca260-517a-4797-b052-9bfdfebc7c49',
      'Culture de céréales et d\'autres cultures n.c.a.': 'bd2d35ad-272a-47ff-8e9b-cb24d6d9a43d',
      'Culture de fruits, de fruits à coque, de plantes à boissons et d\'épices': '1fd1b8cd-14f4-4426-b828-4fb1cad627bf',
      'Culture de légumes, de plantes horticoles et de produits de pépinière': '15a429f3-e1cd-4084-9549-b23e8f73c694',
      'Distillation, rectification et mélange de boissons alcooliques; production d\'alcool éthylique à partir de matières fermentées': 'f04415b8-a0f3-4eea-95dc-cf1ed1ba2d40',
      'Extraction de minerais chimiques et d\'engrais minéraux': 'd30904d5-5a0c-4ea6-9758-9e2a12a4b370',
      'Extraction de minerais de métaux non ferreux, à l\'exception de l\'uranium et du thorium': 'b4ae4283-a299-4cf9-9574-32054d86a91c',
      'Extraction de minerais d\'uranium et de thorium': 'dbeb4e4f-adf0-4238-be78-ed30f9075b83',
      'Extraction de pierre, de sable et d\'argile': '77c346a2-54e9-482b-b7c7-6c408061044a',
      'Extraction de sel': 'd1bd732e-7e99-4caa-a387-9c2f70a07dd0',
      'Extraction et agglomération de houille': '3d4dac5e-7244-4341-a9e5-b5f92816d767',
      'Extraction et agglomération de tourbe': 'b7d6370d-671f-4dee-97c7-c4dba9c4016b',
      'Fabrication de bicyclettes et de véhicules pour invalides': '46f24cb0-f6fe-4cb7-aee6-6617174ef93f',
      'Fabrication de bijoux et d\'articles connexes': '58000659-3b30-496f-aa43-87c1c20d2476',
      'Fabrication de bières de malt et de malt': '3588a0eb-1f5e-49bc-9438-fbc2c659b2be',
      'Fabrication de boissons rafraîchissantes; production d\'eaux minérales et d\'autres eaux embouteillées': '6c3b48ac-be6d-4ae3-9f4c-0581a72f63ff',
      'Fabrication de cacao, de chocolat et de produits de confiserie à base de sucre': '38e67d4e-a98b-4413-834e-c283ea9186c0',
      'Fabrication de carrosseries pour véhicules automobiles; fabrication de remorques et de semi‑remorques': 'df0b8f18-8d5e-4aec-b433-e7123bafc893',
      'Fabrication de charpentes et d\'ouvrages de menuiserie pour la construction': '3523237b-b34d-483e-a6b6-e3928176b98e',
      'Fabrication de chaussures': 'b6ef0f2e-55c9-4610-ae3f-e61611285dd1',
      'Fabrication de ciment, de chaux et de plâtre': '0332c8eb-8666-4c4f-b16c-44fffb03c005',
      'Fabrication de coutellerie, d\'outillage à main et de quincaillerie générale': '65219710-4a46-4db5-8fff-188312628089',
      'Fabrication de câbles, cordages, ficelles et filets': '1aa19c8b-ae87-4227-a5e4-97e6dd974b8c',
      'Fabrication de feuilles de placage; fabrication de contreplaqués, panneaux lattés, panneaux de particules et autres panneaux et plaques en bois': 'bcc92554-91b2-4d15-8a45-f860fdde69ad',
      'Fabrication de fibres artificielles ou synthétiques': 'e75891a8-4e54-49e5-bd8c-f42a26c3956d',
      'Fabrication de fils et câbles isolés': '3f13d5c1-b552-4543-80d9-1fa7dd3d2e4a',
      'Fabrication de fours, de fours industriels et de brûleurs': '7eee6aaf-d407-44b9-a6c3-3606de7eed23',
      'Fabrication de fécules et de produits amylacés': '739291ba-c33d-4d8c-972b-cb77da9e6b53',
      'Fabrication de générateurs de vapeur, à l\'exception des chaudières pour le chauffage central à eau chaude': 'abe1f644-dae3-4f20-a29a-83f71b2d4e2d',
      'Fabrication de jeux et de jouets': '051b3a42-cf01-4869-b793-9d709b4e9c89',
      'Fabrication de lampes électriques et de matériel d\'éclairage': '16b33730-c724-4cd3-8e1a-c206837dc1bc',
      'Fabrication de lampes, tubes et autres composants électroniques': 'daba5502-5f24-497c-a949-0ceddfe7fef0',
      'Fabrication de locomotives et de matériel roulant pour chemins de fer et tramways': 'f1414cea-922f-44fb-9d78-d64f0f90184f',
      'Fabrication de macaroni, nouilles, couscous et autres produits farinacés similaires': '2128995f-fa3e-4a4a-975c-aa5902d53d30',
      'Fabrication de machines agricoles et forestières': '39dc7303-3fe8-4c7f-a646-9b19cf6d1f23',
      'Fabrication de machines de bureau, de matériel de comptabilité et de matériel informatique': '810efd82-7981-4551-836f-33e0e43b1796',
      'Fabrication de machines pour la métallurgie': '31d0d891-da30-4e6e-a4f8-e1e35acacfdc',
      'Fabrication de machines pour les industries alimentaires, des boissons et du tabac': 'c5558940-2a41-4cdc-8d52-b5612faf5e5c',
      'Fabrication de machines pour l\'extraction, la construction et le génie civil': '32b4d9bb-daf3-4173-9867-65d367b6f446',
      'Fabrication de machines pour l\'industrie textile, de l\'habillement et du cuir': 'b0cfa89e-a580-4213-9d71-870ac62f3f60',
      'Fabrication de machines‑outils': 'b99c7344-6b52-42b1-842b-de83938e2e39',
      'Fabrication de matières plastiques de base et de caoutchouc synthétique': '55b5b482-a487-486b-ba68-ea7328fe1fa2',
      'Fabrication de matériel médico‑chirurgical et d\'appareils orthopédiques': 'c8558e06-969c-4e30-8a12-16a83ed1a3d4',
      'Fabrication de meubles': 'd46d4c6b-68c8-43e6-ad9d-be3970c79658',
      'Fabrication de montres et d\'horloges': '43bad8d1-508d-45fa-bbdc-31bd9738df31',
      'Fabrication de moteurs et de turbines, à l\'exception des moteurs pour aéronefs, véhicules automobiles et motocycles': '6b8c109f-68a5-4dc2-b605-2bff64bd5c39',
      'Fabrication de moteurs, générateurs et transformateurs électriques': '3fc2d2ba-d255-45bb-b5f6-0cb1bd3a780a',
      'Fabrication de motocycles': '87ad9c57-7d88-414a-9c05-7e04abfae252',
      'Fabrication de papier et de carton ondulés et de cartons d\'emballage': '01aa2266-6791-40aa-b654-14ac80f3e27e',
      'Fabrication de peintures, vernis et revêtements similaires, d\'encres d\'imprimerie et de mastics': 'f290b50d-097f-4674-8727-9778f248f945',
      'Fabrication de pièces et d\'accessoires pour véhicules automobiles et leurs moteurs': '5aa0d927-c838-4a64-a6d2-393fad299193',
      'Fabrication de pièces pour aéronefs': '985ea98b-c54d-4622-9bee-72ed9a90a6a6',
      'Fabrication de pneumatiques et de chambres à air; rechapage et reconstruction de pneumatiques': '9ccccb4f-82c7-422b-867c-180cd4443f5a',
      'Fabrication de pompes, de compresseurs, de robinets et de vannes': 'b3f0c462-40c1-465b-9039-b967084bddd1',
      'Fabrication de produits chimiques de base, à l\'exception des engrais et des composés azotés': '90371c46-1213-4025-956e-dc1cf18c09fe',
      'Fabrication de produits céramiques non réfractaires à usage non structural': '4752a6fe-8749-4484-8559-4dcdb669eb6a',
      'Fabrication de produits céramiques réfractaires': '6e8adb50-6da4-4819-a10f-369123f2cf22',
      'Fabrication de produits de boulangerie': '037153a7-9c72-42fb-84ef-7917d89f876e',
      'Fabrication de produits de la minoterie': '33bbebe4-d31c-44db-a5b4-3a0abdd067ba',
      'Fabrication de produits du cokéfaction': '3255a413-1d3e-4083-852f-81fe399a9c85',
      'Fabrication de produits en matières plastiques': 'edd75c78-ca14-47fc-840f-1401724b7d3a',
      'Fabrication de produits en terre cuite et de produits céramiques non réfractaires à usage structural': '8b4a36de-c34d-4e47-89c4-836ff6514866',
      'Fabrication de produits laitiers': 'c9f80039-1c53-400a-8b4f-049b72ae29aa',
      'Fabrication de produits pharmaceutiques, de produits chimiques à usage médical et de produits botaniques': 'd2ab98b9-42ac-4515-aed5-ca0ecdb9f073',
      'Fabrication de produits à base de tabac': '6e7d85e2-5088-410f-9ea6-bbeba3bc15d7',
      'Fabrication de pâte à papier, de papier et de carton': '10aef3a6-b734-434a-8ac1-6b448775cace',
      'Fabrication de roulements, d\'engrenages et d\'organes de transmission': 'b6bc6e51-0ef8-46fc-91c3-b87ce1b70842',
      'Fabrication de récepteurs de télévision et de radio, d\'appareils d\'enregistrement ou de reproduction du son et de l\'image et d\'équipements connexes': 'a3ed8d4a-2d68-415f-ab75-4845b6f08045',
      'Fabrication de réservoirs, citernes et conteneurs métalliques': '6db67a34-3e7b-445b-8b0f-31b14518cc2d',
      'Fabrication de savon, de détergents, de produits d\'entretien et de polissage, de parfums et de produits de toilette': 'a87aa8ad-c5be-4cc9-9bad-591c4e01d849',
      'Fabrication de sucre': 'b8cd1860-af83-4dc4-8085-e65579d998dd',
      'Fabrication de tapis et de carpettes': '0b09edf6-68a8-4de5-9b76-3cf735d9d8d4',
      'Fabrication de tissus et d\'articles en bonneterie': 'a21361f2-312c-48fc-bcfe-13fca375a3f7',
      'Fabrication de verre et d\'articles en verre': '868bd07a-e7cb-401d-8c11-1a187d38ffa7',
      'Fabrication de vins': '3df0f3c3-4b7b-42c9-ae92-946d30a2c2e7',
      'Fabrication de véhicules automobiles': 'de418080-db34-4dc2-8add-47c3dbe3d4c6',
      'Fabrication de vêtements, à l\'exception des vêtements en fourrure': 'ac1cc9b0-c3c1-4505-9adb-d1902570d789',
      'Fabrication d\'accumulateurs, de piles et de batteries primaires': '157b1ee8-dce6-4e44-8966-621a901fb53a',
      'Fabrication d\'aliments préparés pour animaux': '4e8f8b1a-0a88-4df9-a383-168d868dd13e',
      'Fabrication d\'appareils ménagers n.c.a.': 'e39d1021-5572-486a-a8be-88c874eb87c7',
      'Fabrication d\'appareils pour la distribution et le contrôle de l\'électricité': 'ff8ab6d4-be44-4ef7-b0aa-03c13e47ee59',
      'Fabrication d\'appareils pour le contrôle des processus industriels': 'e4931df6-c472-45fe-abd2-e5acf79d6f31',
      'Fabrication d\'armes et de munitions': 'e1283741-c8ba-4ce6-afe3-7d6d7f773e37',
      'Fabrication d\'articles de sport': '60b55c42-2ae1-4b52-8213-399d291750a1',
      'Fabrication d\'articles de voyage, de maroquinerie, de sellerie et de harnais': '71e13f32-dc3d-45e5-9bfd-8933cb5b0275',
      'Fabrication d\'autres articles en papier ou en carton': 'd01e85d2-6445-49be-99a9-48e145a7e4f9',
      'Fabrication d\'autres machines d\'usage général ': '79eb9d82-d826-413d-a918-35756d2e1985',
      'Fabrication d\'autres machines d\'usage spécifique': 'e023b523-5828-47e2-a273-6cc58368df08',
      'Fabrication d\'autres matériels de transport n.c.a.': 'a3bdf6fe-eeeb-4d74-9f26-9c9f775171c1',
      'Fabrication d\'autres matériels électriques n.c.a.': '8062a607-8545-4d81-922d-c6b7ced8df92',
      'Fabrication d\'autres ouvrages en métaux n.c.a.': '404e76cb-b161-4f91-b4fb-59bc583e6bea',
      'Fabrication d\'autres produits alimentaires n.c.a..': 'a67141dd-09a2-4110-b844-f6de986f6124',
      'Fabrication d\'autres produits chimiques n.c.a.': '7b92a90d-d8f3-4bba-b4e0-767c5e8388f8',
      'Fabrication d\'autres produits en bois; fabrication d\'articles en liège, vannerie et sparterie': 'ae8b9f6f-42fb-4e87-8d73-4fec2d687cb3',
      'Fabrication d\'autres produits en caoutchouc': 'e4d6b668-f65a-435b-ad5c-0c0a9e9f25ff',
      'Fabrication d\'autres produits minéraux non métalliques n.c.a': '014d4092-9fd3-4b04-bbdd-ecdc4d8d79b3',
      'Fabrication d\'autres textiles n.c.a.': '4bad01dd-6eab-4294-89a6-508a5b9450bd',
      'Fabrication d\'aéronefs': '8ed139e3-e61a-486c-ae7b-e88f5478d500',
      'Fabrication d\'emballages en bois': '4b323deb-c8bb-497c-98f1-e45e19f9804f',
      'Fabrication d\'engrais et de composés azotés': '5535e69c-a503-48fc-b3ca-336aa5ff4917',
      'Fabrication d\'huiles et graisses végétales et animales': '0d9f40ce-ef7a-44e4-af6f-37614b8d62c2',
      'Fabrication d\'instruments de musique': '46392ee5-dfb8-4be1-9010-79e418f7e8a9',
      'Fabrication d\'instruments d\'optique et de matériel photographique': '5371dc65-4cf1-4fde-8d83-a37c7e4b7412',
      'Fabrication d\'instruments et d\'appareils de mesure, de contrôle, d\'essai, de navigation et d\'autres usages': '14e4cc0a-0504-47b1-ba81-2f6613978825',
      'Fabrication d\'ouvrages en béton, en ciment et en plâtre': 'e6b22403-d212-438d-bdc0-45739dfb98dc',
      'Fabrication d\'ouvrages en métaux': '8db6ac69-f7fa-485e-a6ec-a1ef33ad56b7',
      'Fabrication d\'émetteurs de radio et de télévision et d\'appareils pour la téléphonie et le télégraphe filaires': '594d3839-4dcc-4419-b822-923bc9f5e494',
      'Fabrication d\'équipements de levage et de manutention': '2a5efeec-ec1c-4b74-9875-f040ffd18de2',
      'Fabrication de pesticides et d’autres produits agrochimiques': '70edff7b-be8f-4a5a-ab13-73e56b6c955e',
      'Fabrication d’engins spatiaux': '3be9a067-0178-4218-ab46-b8a230377bc3',
      'Extraction et agglomération de lignite': 'e314c3d9-f381-4393-95f3-30d79d0a628f',
      'Métallurgie des métaux précieux et des autres métaux non ferreux': '6d9f1e2f-cf2f-48ba-8dd9-7685ca3563ad',
      'Production et distribution de films cinématographiques et de vidéos': '36af71dd-c7ee-471c-80ea-163d79dd2db8',
      'Préparation et conservation de fruits et de légumes': '1422cce1-ba78-4852-b581-eaa31c57e409',
      'Préparation et conservation de la viande et des produits à base de viande': 'd2cf8274-9fc3-44b3-aae4-73ead9197ea9',
      'Préparation et conservation de poissons, crustacés et mollusques': 'f7f6df2a-687a-4447-9e44-dea19651ed14',
      'Préparation et filature de fibres textiles; tissage de textiles': '0ad19fa4-8cdd-457a-b0e7-a82701d431e2',
      'Pêche, exploitation de piscicultures et de fermes aquacoles; services annexes à la pêche': '85d6870b-7c7b-4275-9172-9a59e4b214ba',
      'Sciage et rabotage du bois': 'c114643e-ddcf-4f6f-90e5-877163164414',
      'Service activities related to Activités d\'imprimerie': 'f088c9f8-664b-4776-96f9-22e0f14c3b24',
      'Sidérurgie et fabrication de fonte et d\'acier': '418c2bea-bb5f-43b7-be6d-0bea460cea83',
      'Sylviculture, exploitation forestière et services annexes': '16ec4c60-9c08-44cc-bc24-4354374ce012',
      'Taille, façonnage et finissage de la pierre': '4158362e-2129-4ed1-b06a-3fa632fb1b86',
      'Traitement de combustibles nucléaires': '03ba1c67-3836-44ae-963a-86908578bfbb',
      'Édition de journaux, de revues et de périodiques': '55fdbb30-4be0-4b31-bb89-9ec739afee20',
      'Édition de livres, de brochures, de partitions musicales et d\'autres publications': '5769d640-f657-4f27-a360-c2c5acf9e610',
      'Édition de supports enregistrés': '91a6bc8c-c7af-4730-8d2d-c58e7f42c6c5',
      'Élevage de bovins, ovins, caprins, chevaux, ânes, mulets et bardots; production laitière': 'eba3c1d4-5877-4b3a-a846-2aa68180231c'
    },
    categoryDisplayNames: {
      'Fabrication de machines pour l\'extraction, la construction et le génie civil': 'Fabrication de machines pour les industries extractrices et de la construction',
      'Fabrication d\'appareils pour le contrôle des processus industriels': 'Fabrication d\'équipements de contrôle des procédés industriels'
    }
  },
  mutations: {
    setDataLoaded(state, status) {
      state.dataLoaded = status
    },
    setChartData(state, { indicator, data }) {
      state.chartData[indicator] = data
    },
    setSelectedCountry(state, country) {
      state.selectedCountry = country
    },
    setSelectedCategory(state, category) {
      state.selectedCategory = category
    },
    setSelectedCompetitor(state, competitor) {
      state.selectedCompetitor = competitor
      // Si on sélectionne Allemagne comme compétiteur et que le pays est Allemagne, changer le pays
      if (competitor === 'Allemagne' && state.selectedCountry === 'Allemagne') {
        state.selectedCountry = 'France';
      }
    }
  },
  actions: {
    loadChartData({ commit }, { indicator, data }) {
      commit('setChartData', { indicator, data })
      commit('setDataLoaded', true)
    },
    setCountry({ commit }, country) {
      commit('setSelectedCountry', country)
    },
    setCategory({ commit }, category) {
      commit('setSelectedCategory', category)
    }
  },
  getters: {
    selectedCountry: state => state.selectedCountry,
    countries: state => Object.keys(state.countryToApiName),
    selectedCategory: state => state.selectedCategory,
    categories: state => {
      return Object.keys(state.categoryToId).map(category => 
        state.categoryDisplayNames[category] || category
      );
    },
    selectedCompetitor: state => state.selectedCompetitor,
    competitors: state => state.competitors,
    availableCountries: state => {
      const allCountries = Object.keys(state.countryToApiName);
      if (state.selectedCompetitor === 'Allemagne') {
        return allCountries.filter(country => country !== 'Allemagne');
      }
      return allCountries;
    },
    getCategoryDisplayName: state => categoryName => {
      return state.categoryDisplayNames[categoryName] || categoryName;
    },
    getCategoryApiName: state => displayName => {
      // Inverse lookup : trouve le nom API à partir du nom d'affichage
      const entry = Object.entries(state.categoryDisplayNames).find(([apiName, display]) => display === displayName);
      return entry ? entry[0] : displayName;
    }
  }
})
